import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'

import './index.css'
import App from './App'
import { store } from './app/store'
import reportWebVitals from './reportWebVitals'
import config from './config/config.json'
import { GoogleReCaptcha, GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

const reCaptchaKey = config.reCaptchaKey
const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(rootElement)

root.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
      <Provider store={store}>
        <GoogleReCaptcha />
        <App />
      </Provider>
    </GoogleReCaptchaProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
